module.exports = __webpack_public_path__ + "img/ci_color.5e3c6579.svg";